export default __webpack_public_path__ + "static/framer-b29ec67a46f717c5f1b91b57dad5efa6.svg";